import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    'html',
    'source',
    'success'
  ]

  connect() {
  }

  copy() {
    this.sourceTarget.value = this.copiedHtml()
    this.sourceTarget.select()
    document.execCommand("copy")

    this.successTarget.classList.remove('d-none')
    this.successTarget.classList.remove('opacity-0')
    this.successTarget.classList.add('opacity-100')
    this.successTarget.classList.add('d-flex')
    setTimeout(() => {
      this.successTarget.classList.add('opacity-0')
      this.successTarget.classList.remove('opacity-100')
    }, 500)

  }

  copiedHtml() {
    const html = this.htmlTarget.cloneNode(true)
    html.style.width = "960px"
    html.style.minWidth = "960px"
    html.style.maxWidth = "960px"
    html.style.paddingLeft = "14px"
    html.style.paddingRight = "14px"
    html.style.boxSizing = "border-box"
    const body = html.querySelector("body")
    if (body) {
      body.style.width = "960px"
      body.style.minWidth = "960px"
      body.style.margin = "0"
      body.style.padding = "0"
      body.innerHTML = `
        <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="960" style="width: 960px; min-width: 960px; max-width: 960px; border-collapse: collapse; margin: 0 auto; background-color: #F7F6F1;">
          <tr>
            <td width="960" style="width: 960px; min-width: 960px; max-width: 960px; padding: 0; background-color: #F7F6F1;">
              ${body.innerHTML}
            </td>
          </tr>
        </table>
      `
    }

    const head = html.querySelector("head")
    if (head && !head.querySelector('meta[name="viewport"]')) {
      const viewport = document.createElement("meta")
      viewport.setAttribute("name", "viewport")
      viewport.setAttribute("content", "width=960")
      head.appendChild(viewport)
    }

    return html.outerHTML
  }

}
